<template>
    <div class="cardResult">
        <div class="greyBackground">
            <span class="tittleCard">{{ tittleCard }}</span>
            <p class="mainAmount mt-2">
                {{ money(mainAmount) }}
            </p>
            <div class="is-flex is-justify-content-space-between">
                <span class="labelSubAmount">
                    {{ mainDetail.label }}
                </span>
                <span :class="[mainDetail.theme, 'px-1']">
                    {{ mainDetail.value }}
                </span>
            </div>
        </div>
        <p class="mt-5 mb-3 tittleSection">{{ tittleSection }}</p>
        <p class="is-flex is-justify-content-space-between" v-for="sectionDetail in sectionDetails"
            :key="sectionDetail.label">
            <span class="labelItem">{{ sectionDetail.label }}</span>
            <span class="valueItem">{{ sectionDetail.value }}</span>
        </p>
    </div>
</template>

<script>
import { parseToMoney } from "@/utils/currency";
export default {
    name: "CardResults",
    components: {
    },
    props: {
        tittleCard: String,
        mainAmount: Number,
        mainDetail: Object,
        tittleSection: String,
        sectionDetails: Array,
    },
    data() {
        return {

        };
    },
    computed: {

    },
    methods: {
        money(value) {
            if (value != "") {
                return parseToMoney(value);
            } else {
                return '$0'
            }
        },

    },
    mounted() {

    },

    watch: {
    }
};
</script>
<style lang="scss" scoped>
* {
    font-family: Inter;
    font-feature-settings: 'ss11' on, 'liga' off, 'calt' off;
}

.cardResult {
    padding: 12px 12px 20px 12px;
    align-self: stretch;

    border-radius: var(--radius-16, 16px);
    border: 1px solid var(--stroke-soft-200, #EBEBEB);
    background: var(--bg-white-0, #FFF);
    box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
}

.greyBackground {
    padding: 16px 12px;

    border-radius: 16px;
    border: 1px solid #EBEBEB;
    background: #EAECF0;
}

.tittleCard {
    color: var(--text-sub-600, #5C5C5C);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.084px;
}

.mainAmount {
    color: var(--text-strong-950, #171717);
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 44px;
    letter-spacing: -0.16px;
}

.labelSubAmount {
    color: #5C5C5C;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.084px;
}

// .percentSubAmount {
//     border-radius: 16px;
//     border: 1px solid #AAF1F7;
//     background: #EDFDFE;

//     color: #157389;
//     text-align: center;
//     font-family: Inter;
//     font-size: 14px;
//     font-style: normal;
//     font-weight: 500;
//     line-height: 20px;
// }

@mixin themePercent($background-color, $border-color, $color-text) {
    border-radius: 16px;
    border: 1px solid $border-color;
    background: $background-color;
    color: $color-text;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}

.themePercentGreen {
    @include themePercent(#EDFDFE, #AAF1F7, #157389);
}

.themePercentBlue {
    @include themePercent(#F3F8FB, #CFDFEE, #4C6CA9);
}

.themePercentOrange {
    @include themePercent(#FEFCE8, #FEF189, #A16307);
}

.themePercentPurple {
    @include themePercent(#F4F3FF, #DBD6FE, #6428D9);
}


.tittleSection {
    color: var(--text-sub-600, #5C5C5C);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.084px;
}

.labelItem {
    color: #5C5C5C;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.084px;
}

.valueItem {
    color: var(--text-sub-600, #5C5C5C);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.084px;
}
</style>